import { useState, useEffect, useContext } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Link, useParams, useNavigate } from "react-router-dom";
import { Input, TextArea, Select, TextAreaAdvanced } from "../../../../../Layout/Forms/Form";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import VipTablesRequests from '../VipTablesRequests';

const FormPaymentWithdrawal = ({ show, handleModalhide }) => {
    let params = useParams();
    const [isLoading, setIsLoading] = useState(false);
    const [state, setState] = useState({
        form: {
            value: ""
        },
        errors: [],
    })

    const handleChangeInputs = (e) => {
        if (!isLoading) {
            setState({
                ...state,
                form: {
                    ...state.form,
                    [e.target.name]: e.target.value
                }
            });
        }
    }

    const handleSubmitForm = async () => {
        let info = await VipTablesRequests.requestPaymentWithdrawal({ ...state.form, id_venues: params.id });
        if (info && info.status) {
            toast.success("Os seu pedido foi registado com sucesso", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
            });
            handleModalhide()
        } else {
            setState({
                ...state,
                errors: info.errors
            })
        }
    }

    return (
        <Modal
            show={show}
            onHide={handleModalhide}
            centered
            contentClassName="campaign-card border-0"
        >
            <Modal.Header closeButton className="border-0 pb-0">
                <Modal.Title className="fw-bold text-white">Solicitar Levantamento</Modal.Title>
            </Modal.Header>

            <Modal.Body className="pt-4">
                <div className="instruction-box border-0 mb-4 p-3 rounded-4" style={{ background: 'rgba(10, 194, 130, 0.1)' }}>
                    <div className="d-flex align-items-center">
                        <i className="fa-solid fa-circle-info fs-4 text-success me-3"></i>
                        <p className="mb-0 small text-white">O processamento do pedido de levantamento pode demorar até 48H úteis.</p>
                    </div>
                </div>

                <div className="row">
                    <div className="col-12">
                        <Input
                            label="Valor a levantar (€)"
                            name="value"
                            placeholder="0.00"
                            value={state.form.value}
                            onChange={(e) => handleChangeInputs(e)}
                            type="number"
                            class="form-control form-input text-end bg-transparent fs-4 fw-bold text-white py-3"
                            errors={state.errors}
                        />
                    </div>
                </div>
            </Modal.Body>

            <Modal.Footer className="border-0 pt-0 pb-4 px-4">
                <div className="row w-100 g-2">
                    <div className="col-6">
                        <button className="btn-action btn-campaign-secondary w-100 py-3 rounded-pill" onClick={handleModalhide}>
                            Cancelar
                        </button>
                    </div>
                    <div className="col-6">
                        <button className="btn-action btn-campaign-primary w-100 py-3 rounded-pill" onClick={handleSubmitForm}>
                            Confirmar
                        </button>
                    </div>
                </div>
            </Modal.Footer>
        </Modal>
    )
}

export default FormPaymentWithdrawal;
